module.exports = __webpack_public_path__ + "static/media/SMS.edca97b4.svg";